module.exports = __webpack_public_path__ + "static/media/notify.25d7d03d.svg";